var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mb-6"},[_c('app-heading',{attrs:{"element":"h2"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.subTitle)?_c('span',{staticClass:"block mt-1 text-sm text-grey-darker",domProps:{"innerHTML":_vm._s(_vm.subTitle)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617c21cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = null
// module chunks = 